<template>
  <div class="container-fluid">
    <first-start v-if="doFirstStart"/>
    <Navbar-FeedCategories :categories="this.$store.state.StaticFeeds.items" routeName="static" />
    <Content-Static :feeds="this.$store.state.StaticFeeds" routeName="static"/>
    <navbar-dynamic-bars :feeds="this.$store.state.StaticFeeds" routeName="staticWithPage" />
  </div>
</template>

<script>
// @ is an alias to /src
import NavbarFeedCategories from '@/components/Navbars/Navbar.FeedCategories.vue'
import NavbarDynamicBars from '@/components/Navbars/NavbarDynamicBars.vue'
import FirstStart from '@/components/FirstStart.vue'
import ContentStatic from '@/components/ContentStatic.vue'

export default {
  name: 'home',
  components: {
    NavbarFeedCategories,
    NavbarDynamicBars,
    ContentStatic,
    FirstStart
  },
  computed: {
    doFirstStart: function () {
      if ( !window.localStorage.getItem('FirstStart'))
        {
          window.localStorage.setItem('FirstStart', true );
        return true;
        }
      else
        return false;
    }
  }
 
}
</script>
